/**
 * 保存操作记录
 * @param {*} clientId 目标ID
 * @param {*} operation 具体操作
 * @param {*} user 谁
 * @param {*} model 模块
 * @param {*} this_ VUE
 * @param {*} deal 回调函数
 */
export function saveOperationRecords(
  clientId,
  operation,
  user,
  model,
  this_,
  deal,
) {
  let requestData = {
    clientId: clientId,
    operation: operation,
    userId: user.userId,
    model: model, // contract  client  thread  invoice
  };

  this_.$request(
    "post",
    "/operation/saveOperationRecords",
    requestData,
    (data) => {
      deal(data);
    },
    (errorMessage) => {
      this_.$message.error("保存操作记录失败!");
    },
  );
}

/**
 * 查看角色操作日志（客户业务角色变更流水）
 * 复用操作记录的弹窗展示（genjinjilu），内容取自 /clientRoleChangeLog/pageByClient
 * @param {*} clientId 客户ID
 * @param {*} this_
 */
export function showRoleChangeLog(clientId, this_) {
  let requestData = {
    clientId: clientId,
    current: 1,
    size: 100,
  };

  this_.$request(
    "post",
    "/clientRoleChangeLog/pageByClient",
    requestData,
    (data) => {
      let list = [];
      if (data && data.records) {
        data.records.forEach((element) => {
          let dd = {
            icon: element.operatorIcon,
            name: element.operatorName,
            content: element.remark,
            // model置为archives：日志组件据此把时间文案展示为“操作时间”
            model: "archives",
            time: element.operTime,
          };
          list.push(dd);
        });
      }
      if (list.length == 0) {
        this_.$message.error("暂无角色操作日志!");
        return;
      }
      this_.dialogData.title = "角色操作日志";
      this_.dialogData.width = "30%";
      this_.dialogData.buttonArray = [];
      this_.dialogData.data = [
        {
          type: "genjinjilu",
          value: {
            hasContent: false,
            content: "",
            time: "",
            list: list,
            hasTarget: false,
            target: "",
            hasPhase: false,
            phase: "",
            clientId: clientId,
          },
          title: "",
        },
      ];
      this_.dialogData.flag = true;
    },
    (errorMessage) => {
      this_.$message.error("角色操作日志查看失败!");
    },
  );
}

/**
 * 查看操作记录
 * @param {*} clientId 目标ID
 * @param {*} model
 * @param {*} this_
 * @param {*} deal
 */
export function showOperationRecords(clientId, model, this_) {
  let requestData = {
    clientId: clientId,
    model: model, // contract  client  thread  invoice archives
  };

  this_.$request(
    "post",
    "/operation/showOperationRecords",
    requestData,
    (data) => {
      if (data.length > 0) {
        this_.dialogData.title = "操作记录";
        this_.dialogData.width = "30%";
        this_.dialogData.buttonArray = [];
        this_.dialogData.data = [];
        let list = [];
        data.forEach((element) => {
          let dd = {
            icon: element.icon,
            name: element.userName,
            content: element.operation,
            time: element.time,
            model: model,
            clientDemandStatus: element.clientDemandStatus,
          };
          list.push(dd);
        });
        let dd = {
          type: "genjinjilu",
          value: {
            hasContent: false,
            content: "",
            time: "",
            list: list,
            hasTarget: false,
            target: "",
            hasPhase: false,
            phase: "",
            clientId: clientId,
          },
          title: "",
        };
        this_.dialogData.data.push(dd);
        this_.dialogData.flag = true;
      } else {
        this_.$message.error("暂无操作记录!");
      }
    },
    (errorMessage) => {
      this_.$message.error("操作记录查看失败!");
    },
  );
}
